import {
  Box,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import CustomInput from "../../components/inputs/CustomInputs";
import { memo } from "react";
import { Close } from "@mui/icons-material";
import SubmitButton from "../../components/button/SubmitButton";
import AddProductAccessories from "./AddProductAccessories";
import AddIcon from "@mui/icons-material/Add";
import AddProductProblem from "./AddProductProblem";
import AddProductItem from "./AddProductItem";
import { CATEGORIES } from "../../utils/constants";
import { titleCase, toTitleCase } from "../../utils/main";

const CreateProductUi = ({
  title,
  isUpdate,
  fields,
  setFields,
  loading,
  onSubmit,
  isModal,
  handleAreaModalClose,
}) => {
  return (
    <>
      {!isModal && (
        <CustomDialog
          id={`${isUpdate ? "update" : "Product"}`}
          loading={loading}
          err={fields.err}
          onSubmit={onSubmit}
          title={`${isUpdate ? "Update" : "Create"} ${title}`}
          closeText="Close"
          confirmText={`${isUpdate ? "Update" : "Create"}`}
        >
          {loading ? (
            <CenteredBox>
              <CircularProgress />
            </CenteredBox>
          ) : (
            <>
              {
                <CustomInput
                  autoFocus={true}
                  disabled={loading}
                  value={fields.name}
                  onChange={(e) =>
                    setFields({ ...fields, err: "", name: e.target.value })
                  }
                  type="text"
                  label={"Product Name*"}
                />
              }

              <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
                <InputLabel >Select Category</InputLabel>
                <Select
                  value={fields.categories}
                  label="Select Category"
                  onChange={(e) => {
                    setFields({
                      ...fields,
                      err: '',
                      categories: e.target.value,
                      // status
                    });
                  }}
                >
                  <MenuItem value={CATEGORIES.LIFE_STYLE}>Life Style</MenuItem>
                  <MenuItem value={CATEGORIES.HEARING_AID}>Hearing Aid</MenuItem>
                  <MenuItem value={CATEGORIES.OTHER_PROJECTS}>Other Projects</MenuItem>
                  {/* <MenuItem value={PAYMENT_METHOD.RETURN_DEVICE}>{titleCase(PAYMENT_METHOD.RETURN_DEVICE)}</MenuItem> */}
                </Select>
              </FormControl>

              <Box sx={{ border: "2px solid #1D013B", borderRadius: "4px", padding: "10px" }}>
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Is 3 Year Warranty ?
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={fields.is_3yr_warranty}

                    //   console.log("e",e.target.value),
                    onChange={(e) => {
                      setFields({
                        ...fields,
                        err: "",
                        is_3yr_warranty: e.target.value,
                      })
                    }
                    }
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
              <Box
                sx={{
                  border: "1px solid black",
                  borderRadius: "8px",
                  padding: 2,
                  mt: 2,
                }}
              >
                <Box ml={1}>
                  <Typography variant="h5">Product Parts</Typography>
                </Box>
                {
                  <Box>
                    <AddProductItem fields={fields} setFields={setFields} />
                  </Box>
                }
                {
                  <Box
                    mt={2}
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"center"}
                  >
                    <IconButton
                      onClick={() => {
                        setFields((data) => {
                          let arr = [...data.item];
                          arr.push({
                            name: "",
                            price: 0,
                          });
                          return { ...data, item: arr };
                        });
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "50%",
                          border: "2px solid",
                        }}
                      >
                        <AddIcon sx={{ width: "100%", height: "4vh" }} />
                      </Box>
                    </IconButton>
                  </Box>
                }
              </Box>
              <Box
                sx={{
                  border: "1px solid black",
                  borderRadius: "8px",
                  padding: 2,
                  mt: 2,
                }}
              >
                <Box ml={1}>
                  <Typography variant="h5">Product Problems</Typography>
                </Box>
                {
                  <Box>
                    <AddProductProblem fields={fields} setFields={setFields} />
                  </Box>
                }
                {
                  <Box
                    mt={2}
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"center"}
                  >
                    <IconButton
                      onClick={() => {
                        setFields((data) => {
                          let arr = [...data.problems];
                          arr.push({
                            name: "",
                            warrenty: 0,
                          });
                          return { ...data, problems: arr };
                        });
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "50%",
                          border: "2px solid",
                        }}
                      >
                        <AddIcon sx={{ width: "100%", height: "4vh" }} />
                      </Box>
                    </IconButton>
                  </Box>
                }
              </Box>
              <Box
                sx={{
                  border: "1px solid black",
                  borderRadius: "8px",
                  padding: 2,
                  mt: 2,
                }}
              >
                <Box ml={1}>
                  <Typography variant="h5">Product Accessories</Typography>
                </Box>
                {
                  <Box>
                    <AddProductAccessories
                      fields={fields}
                      setFields={setFields}
                    />
                  </Box>
                }
                {
                  <Box
                    mt={2}
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"center"}
                  >
                    <IconButton
                      onClick={() => {
                        setFields((data) => {
                          let arr = [...data.product_accessories];
                          arr.push({
                            name: "",
                          });
                          return { ...data, product_accessories: arr };
                        });
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          borderRadius: "50%",
                          border: "2px solid",
                        }}
                      >
                        <AddIcon sx={{ width: "100%", height: "4vh" }} />
                      </Box>
                    </IconButton>
                  </Box>
                }
              </Box>
            </>
          )}
        </CustomDialog>
      )}
    </>
  );
};
export default memo(CreateProductUi);
